
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const Ticketunloadingaction = (props) => {
    //console.log("LoadingDelay ",props);
    const handleUnLoadingDelayClick = (e) => {
        e.stopPropagation();
        
       props.context.componentParent.onShowUnLoadingDelayKpi(props);
    };
   
    return (
        <div>
           <button onClick={handleUnLoadingDelayClick} className="custom-btn f22 label label-success" title="UnLoading Delay" ><i className="icofont icofont-vehicle-delivery-van mildgreen"></i> &nbsp;</button>
            
        </div>
    );
};

export default Ticketunloadingaction;
